import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreatePaymentRequest } from '../models/create-payment.model';
import { ExecutePaymentRequest } from '../models/execute-payment.model';

@Injectable({
    providedIn: 'root'
})
export class PayPalApiService {
    private authHeaders: HttpHeaders;

    constructor(private httpClient: HttpClient) { }

    createdPayment(payment: CreatePaymentRequest, access_token: string, url: string): Observable<any> {
        this._setAuthHeaders(access_token);
        return this.httpClient.post(this.normalizeUrl(url) + '/CreatePayment', payment, { headers: this.authHeaders });
    }

    executePayment(executePayment: ExecutePaymentRequest, access_token: string, url: string): Observable<any> {
        this._setAuthHeaders(access_token);
        return this.httpClient.post(this.normalizeUrl(url) + '/ExecutePayment', executePayment, { headers: this.authHeaders });
    }

    normalizeUrl(url: string): string {
        if (url.length > 0 && url.charAt(url.length - 1) == '/') {
            url = url.substr(0, url.length - 1);
        }
        return url;
    }

    private _setAuthHeaders(access_token: string) {
        const userToken = 'Bearer ' + access_token;
        this.authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': userToken });
    }
}